export const varRegexp = new RegExp(/^var\((.+)\)$/i);

export const getCSStyles = (object: object, addImportantFlag = false): string =>
  Object.entries(object || {})
    .map(([key, rule]) => `${key}:${rule}${addImportantFlag ? '!important' : ''};`)
    .join('');

export const getCssValue = <T = string>(object: Record<string, T>, key: string, fallback: T): T => {
  return object[key] || fallback;
};

export const extractCSSFromVariable = (value: string): string | undefined => {
  const cssVar = varRegexp.exec(value);
  if (cssVar) {
    return cssVar[1];
  }
  return undefined;
};
